module.exports = __webpack_public_path__ + "img/Invasion-OVCA_10X_TIP.3db2db8e.png";